import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { H3 } from 'foundations-components/transitional/components/H3';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Spacer } from 'foundations-components/components/Spacer';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import { rpcClient } from 'asset-actions-lib-forms/utils/client';
import { FORM_ACTION_IDS } from 'asset-actions-lib-forms/constants/actionIds';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import { migrateLegacyFormRpc } from '../../../__generated__/chirp/com/hubspot/forms/rpc/HubSpotFormsSkillsService';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DISCLOSURE_LIST = {
  logic: 'assetActionsLibForms.modals.smartCopyDialog.disclosureList.logic'
};
const SmartyCopyFormDialog = ({
  crmObject,
  onClose
}) => {
  const {
    onActionError,
    onActionSuccess
  } = useAssetActions();
  const legacyFormId = getPropertyValue(crmObject, 'hs_form_id');
  const isV4Form = getPropertyValue(crmObject, 'hs_embed_version') === EmbedVersions.V4;
  const trackDashboardInteraction = actionType => {
    onActionSuccess === null || onActionSuccess === void 0 || onActionSuccess({
      actionId: FORM_ACTION_IDS.SMART_COPY,
      data: {
        actionType
      }
    });
  };
  const onCloseClick = () => {
    trackDashboardInteraction('smart-copy-cancel-clicked');
    onClose();
  };
  const onConfirm = async () => {
    try {
      trackDashboardInteraction('smart-copy-proceed-clicked');
      await rpcClient.call(migrateLegacyFormRpc, {
        request: {
          legacyFormId
        }
      });
      onClose();
      FloatingAlertStore.addAlert({
        id: 'smart-copy-legacy-form',
        type: 'info',
        closeable: true,
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.alerts.smartCopy.success.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.alerts.smartCopy.success.body"
        })
      });
    } catch (error) {
      if (!onActionError) {
        return;
      }
      FloatingAlertStore.addAlert({
        id: 'smart-copy-legacy-form',
        type: 'danger',
        closeable: true,
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.alerts.smartCopy.error.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.alerts.smartCopy.error.body"
        })
      });
      onActionError({
        actionId: FORM_ACTION_IDS.SMART_COPY,
        error: error
      });
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "smart-copy-form-dialog",
    onEsc: onCloseClick,
    use: "conversational",
    children: [/*#__PURE__*/_jsx(Ribbon, {
      use: "beta",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.smartCopyDialog.beta"
      })
    }), /*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H3, {
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.smartCopyDialog.header"
        })
      }), /*#__PURE__*/_jsx(AIBadge, {})]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      textAlign: "left",
      children: [/*#__PURE__*/_jsx(Text, {
        marginBlockStart: "400",
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.smartCopyDialog.description"
        })
      }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(List, {
        styled: true,
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "assetActionsLibForms.modals.smartCopyDialog.noteOne"
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "assetActionsLibForms.modals.smartCopyDialog.noteTwo"
          })
        })]
      }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx(Text, {
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "assetActionsLibForms.modals.smartCopyDialog.disclosure"
        })
      }), /*#__PURE__*/_jsx(List, {
        styled: true,
        children: Object.entries(DISCLOSURE_LIST).map(([key, value]) => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: value
          })
        }, key))
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "smart-copy-form-dialog-proceed",
        disabled: isV4Form,
        onClick: () => {
          void onConfirm();
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.smartCopyDialog.proceed"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "smart-copy-form-dialog-cancel",
        onClick: onCloseClick,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.smartCopyDialog.cancel"
        })
      })]
    })]
  });
};
export default SmartyCopyFormDialog;